import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=c40be234&scoped=true"
import script from "./listInfo.vue?vue&type=script&lang=js"
export * from "./listInfo.vue?vue&type=script&lang=js"
import style0 from "./listInfo.vue?vue&type=style&index=0&id=c40be234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40be234",
  null
  
)

export default component.exports